import { cva } from '@/styled-system/css';

export const labeledInputRecipe = cva({
  base: {
    'display': 'inline-block',
    'position': 'relative',
    'width': '100%',

    // Input styles
    '& > .c11n_input': {
      'paddingBlockStart': 'loose',
      'paddingBlockEnd': 'tighter',

      '&::placeholder': {
        transition: {
          _motionReduce: 'none',
          _motionSafe: '{color 0.15s ease}',
        },
      },

      '&:not(:focus)::placeholder': {
        color: 'transparent.invisible',
      },
    },

    // Label styles
    '& > .c11n_label': {
      'textStyle': 'body',
      'position': 'absolute',
      'insetInlineStart': 'default',
      'transform': 'translateY({spacing.default})',
      'transformOrigin': '0 0',
      'pointerEvents': 'none',
      'truncate': true,
      'maxWidth': 'calc(100% - {spacing.default})',

      '&:has(+ .c11n_input:focus), &:has(+ .c11n_input:not(:placeholder-shown)), &:has(+ .c11n_input:autofill), &:has(+ .c11n_input:read-only)':
        {
          textStyle: 'body-xs-bold',
          transform: 'translateY({spacing.tighter})',
        },

      'transition': {
        _motionReduce: 'none',
        _motionSafe: '{all 0.15s ease}',
      },
    },
  },
  variants: {
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        '& > .c11n_label': {
          insetInlineStart: 'none',
        },
      },
      false: {},
    },
  },
});
